/** Stored on pet quote / `pets.age_category` (VARCHAR); labels shown in UI and My Requests. */

export type PetAgeOption = { value: string; label: string };

const monthBands: PetAgeOption[] = [
  { value: '0_2_months', label: '0–2 months' },
  { value: '2_6_months', label: '2–6 months' },
  { value: '6_months_to_1_year', label: '6 months to a year' },
];

const yearBands: PetAgeOption[] = Array.from({ length: 20 }, (_, i) => {
  const y = i + 1;
  return {
    value: `${y}_year`,
    label: y === 1 ? '1 year' : `${y} years`,
  };
});

const tail: PetAgeOption[] = [{ value: '21_plus_years', label: '21+ years' }];

export const PET_AGE_OPTIONS: readonly PetAgeOption[] = [...monthBands, ...yearBands, ...tail];

const labelByValue = new Map<string, string>(PET_AGE_OPTIONS.map((o) => [o.value, o.label]));

/** Older submissions before age buckets changed */
const LEGACY_LABELS: Record<string, string> = {
  under_1: 'Under 1 year',
  '1_2': '1–2 years',
  '3_5': '3–5 years',
  '6_9': '6–9 years',
  '10_plus': '10+ years',
};

export function getPetAgeLabel(value: string): string {
  if (!value) return '—';
  return labelByValue.get(value) ?? LEGACY_LABELS[value] ?? value.replace(/_/g, ' ');
}
